import { FC, useMemo, useContext, PropsWithChildren } from 'react';
import useCoordinatingGroups from '@/hooks/data/useCoordinatingGroups';
import CoordinatingGroupsContext from '@/contexts/data/CoordinatingGroupsContext';
import { QueryCoordinatingGroupsResponse } from '@/api/dtos';
import IsLoading from '@/components/layouts/IsLoading';
import TrialContext from '@/contexts/data/TrialContext';


export interface ICoordinatingGroupsProviderProps {
    initial?: QueryCoordinatingGroupsResponse;
}

export const CoordinatingGroupsProvider: FC<PropsWithChildren<ICoordinatingGroupsProviderProps>> = ({ initial, children }) => {
    const { data: trial } = useContext(TrialContext);
    const context = useCoordinatingGroups(trial ? {trialId: trial.id} : undefined, { revalidateOnFocus: false, fallbackData: initial});

    return (

        <CoordinatingGroupsContext.Provider value={context}>
            <IsLoading name="coordinating-groups" loading={context.loading} validating={context.validating}/>
            {children}
        </CoordinatingGroupsContext.Provider>
    );
}

export default CoordinatingGroupsProvider;
